
import React from "react";
import { SkillCard } from "./SkillCard";
import { Skill } from "./types";
import { motion } from "framer-motion";

interface SkillsListProps {
  filteredSkills: Skill[];
  onStartAssessment: (skillName: string) => void;
}

export const SkillsList = ({ filteredSkills, onStartAssessment }: SkillsListProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {filteredSkills.map((skill, index) => (
        <motion.div
          key={skill.id}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.05, duration: 0.3 }}
          className="h-full"
        >
          <SkillCard 
            skill={skill} 
            onStartAssessment={onStartAssessment} 
          />
        </motion.div>
      ))}
      {filteredSkills.length === 0 && (
        <div className="col-span-full bg-white/50 neo-glass rounded-xl text-center py-12 text-gray-500">
          <p className="text-lg font-medium">No skills match the selected filters.</p>
          <p className="text-sm mt-2">Try changing your filter criteria.</p>
        </div>
      )}
    </div>
  );
};
